const { TextControl, TextareaControl } = wp.components;
const { registerPlugin  } = wp.plugins;
const { PluginDocumentSettingPanel } = wp.editor;
const { useSelect, useDispatch } = wp.data;
const { __ } = wp.i18n;



/**
 * Represents a Date and Time panel for an event in a calendar.
 *
 * This component allows users to select and edit the event date and time using a DateTimePicker component.
 *
 * @return {JSX.Element} The CustomMetaPanel component
 */
export const CustomMetaPanel = () => {

	const customTitle = useSelect( ( select ) => (
		select( 'core/editor' ).getEditedPostAttribute( 'meta' ).single_guide_title
	), [] );

	const customDescription = useSelect( ( select ) => (
		select( 'core/editor' ).getEditedPostAttribute( 'meta' ).single_guide_description
	), [] );

	const { editPost } = useDispatch( 'core/editor' );

	return (
		<>
			<TextControl
				__next40pxDefaultSize
				help={__( 'Fill in if you want to display a different post title.', 'wombat' )}
				label={__( 'Title', 'wombat' )}
				onChange={( value ) => {

					editPost( { meta: { single_guide_title: value } } );

				}}
				value={customTitle}
			/>

			<TextareaControl
				label={__( 'Description', 'wombat' )}
				help={__( 'Fill in if you want to display a different post description.', 'wombat' )}
				value={ customDescription }
				onChange={( value ) => {

					editPost( { meta: { single_guide_description: value } } );

				}}
			/>
		</>
	);

};


registerPlugin( 'guide-custom-panel', {
	render: () => {

		const postType = useSelect( select => select( 'core/editor' ).getCurrentPostType(), [] );

		if ( postType !== 'smoobu_guide' ) {

			return null;

		}

		return (
			<PluginDocumentSettingPanel
				name="guide-custom-panel"
				title="Custom title and description"
				className="guide-custom-panel"
			>
				<CustomMetaPanel/>
			</PluginDocumentSettingPanel>
		);

	},
} );
